import { render, staticRenderFns } from "./card-statistics-yuri.vue?vue&type=template&id=fbdb5328&scoped=true&"
import script from "./card-statistics-yuri.vue?vue&type=script&lang=js&"
export * from "./card-statistics-yuri.vue?vue&type=script&lang=js&"
import style0 from "./card-statistics-yuri.vue?vue&type=style&index=0&id=fbdb5328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdb5328",
  null
  
)

export default component.exports